import Tags from "./Tags.jsx";

export default Tags;
